import Tag from '@cobliteam/ui/components/Tag';
import type { ReactNode } from 'react';

interface SetupGuideFormRowProps {
  /** Row label rendered as the left Tag — e.g. "Usuário 1", "Grupo 1", "Porte pequeno". */
  label: string;
  children: ReactNode;
}

/**
 * One labeled row of a Setup Guide creation form (Figma "Fluxos das tarefas"): a grey Tag on the
 * left and the row's fields on the right, with a full-width divider between rows.
 */
const SetupGuideFormRow = ({ label, children }: SetupGuideFormRowProps) => (
  <div className='flex items-start gap-6 border-gray-3 border-b py-6 first:pt-2 last:border-b-0 last:pb-2'>
    {/* mt-7 drops the Tag to the input line (below the field labels), matching the Figma alignment. */}
    <Tag color='default' size='sm' label={label} className='mt-7 w-28 shrink-0 justify-center' />
    <div className='flex flex-1 flex-wrap items-start gap-4'>{children}</div>
  </div>
);

export default SetupGuideFormRow;
